import dayjs from "dayjs";

/**
 * Returns boolean if date is empty
 * @param dateStr - string which has format mm/dd/yyy
 */
export const isValidDate = (dateStr: string): boolean => {
  const dateObject = new Date(dateStr);
  return !isNaN(dateObject.getTime());
};

export const getCurrentStrDate = (): string => {
  return dayjs(new Date()).format('MM/DD/YYYY');
}

/**
 * Returns the year based on the current date relative to October 1st.
 *
 * - If the current date is before October 1st of the current year,
 *   it returns the current year.
 * - If the current date is on or after October 1st,
 *   it returns the next year.
 *
 * @returns {number} The current or next year based on the October 1st cutoff.
 *
 * @example
 * // Assuming today is September 30, 2025
 * getYearBasedOnOctober(); // returns 2025
 *
 * @example
 * // Assuming today is October 1, 2025
 * getYearBasedOnOctober(); // returns 2026
 */
export const getTaxableYear = () => {
  const today = new Date();
  const currentYear = today.getFullYear();
  const octoberFirst = new Date(currentYear, 9, 1);
  return today < octoberFirst ? currentYear : currentYear + 1;
}
